module.exports = __webpack_public_path__ + "img/tipsempty.75984ad3.png";